import { render } from "./FixedBackground.vue?vue&type=template&id=bcc52d48&ts=true"
import script from "./FixedBackground.vue?vue&type=script&lang=ts"
export * from "./FixedBackground.vue?vue&type=script&lang=ts"

import "./FixedBackground.vue?vue&type=style&index=0&id=bcc52d48&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__